import React, { useEffect, useState, useContext } from "react";
import { PageLayout } from "../components/page-layout";
import { getLeaderboardGraphResource } from "../services/leaderboard-graph.service";
import { LeaderboardContext } from "../contexts/leaderboard-context";
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { TableContainer, Paper, Table, TableCell, TableBody, TableHead, TableRow } from "@mui/material";


export const LeaderboardGraphPage = () => {
  const {leaderboardData} = useContext(LeaderboardContext);
  const [leaderboardGraphData, setLeaderboardGraphData] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const getLeaderboardGraphData = async () => {
      const { data, error } = await getLeaderboardGraphResource();
      if (!isMounted) { return; }
      if (data) { setLeaderboardGraphData(parseGraphData(data)); }
    };

    getLeaderboardGraphData();

    return () => {
      isMounted = false;
    };
  }, []);

  const parseGraphData = (data) => {
    // Parse the data to get the leaderboard graph data
    const clubs = data.clubs;
    const players = data.players;
    const leaderboardGraphData = [];
    clubs.forEach((club) => {
      const cid = club.cid;
      const week = club.week;
      const pid = club.pid;
      const score = players[pid][week-1];
      if (!leaderboardGraphData[cid]) {
        leaderboardGraphData[cid] = { cid: cid, week: [] };
      }
      if (!leaderboardGraphData[cid].week[week]) {
        leaderboardGraphData[cid].week[week] = { week: week, score: 0 };
      }
      if(cid == 11 && week == 32) {
        //debugger;
      }
      leaderboardGraphData[cid].week[week].score += score;
    });
    return leaderboardGraphData;
  }

  const getClubNameFromId = (clubId) => {
    const club = leaderboardData.find((club) => club.club_id === clubId);
    return club ? club.club_name : "Unknown Club";
  }

  return (
    <PageLayout>
      <TableContainer component={Paper}>
      {leaderboardGraphData.length > 0 && (
      <Table sx={{ minWidth: 390 }} size="small">
        <TableHead>
          <TableRow>
            <TableCell style={{ minWidth: 189 }}>Club</TableCell>
            <TableCell>Week 32</TableCell>
            <TableCell>Week 33</TableCell>
            <TableCell>Week 34</TableCell>
            <TableCell>Week 35</TableCell>
            <TableCell>Week 36</TableCell>
            <TableCell>Week 37</TableCell>
            <TableCell>Week 38</TableCell>
            <TableCell>Window Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {leaderboardGraphData.map((row) => (
            <TableRow
              key={row.cid}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              hover
            >
              <TableCell component="th" scope="row">{getClubNameFromId(row.cid)}</TableCell>
              <TableCell align="right">{row.week[32].score}</TableCell>
              <TableCell align="right">{row.week[33].score}</TableCell>
              <TableCell align="right">{row.week[34].score}</TableCell>
              <TableCell align="right">{row.week[35].score}</TableCell>
              <TableCell align="right">{row.week[36].score}</TableCell>
              <TableCell align="right">{row.week[37] ? row.week[37].score : 0}</TableCell>
              <TableCell align="right">{row.week[38] ? row.week[38].score : 0}</TableCell>
              <TableCell align="right">{row.week[32].score + row.week[33].score + row.week[34].score + row.week[35].score + row.week[36].score}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      )}
      
    </TableContainer>
    </PageLayout>
  );
};
